import { createAction, props } from '@ngrx/store';

export const setNavbarState = createAction(
  '[App] Set Navbar State',
  props<{ navBarState: string }>()
);